<div class="outer-container">
  <app-current-path></app-current-path>
  <div class="console-container">
    <div>
      <span class="action-name">{{ action }}</span
      ><span class="records"> ({{ totalRecords }} records found)</span>
    </div>
    <div class="input-wrapper">
      <app-console-search
        [findOptions]="findOptions"
        [showDateRange]="showDateRange"
        [headercount]="headercount"
        [showHideHeaderColumnCount]="true"
        (clearSearchBoxEvent)="clearSearchBox()"
        (clearFilterEvent)="clearFilter()"
        (applyFilterByFieldEvent)="applyFilterByField($event)"
        (showHideColumnsEvent)="showHideColumns()"
        [initialFromDate]="fromDate" 
        [initialToDate]="toDate"
        [isAIInteractions]="true"
        (resetDateRangeEvent)="resetDateRange($event)"
        (applySelectedDateRangeEvent)="applySelectedDateRange($event)"
      ></app-console-search>
    </div>
    <p-table
      [columns]="cols"
      [value]="auditList"
      [lazy]="true"
      (onLazyLoad)="loadAudits($event)"
      dataKey="id"
      [tableStyle]="{ 'min-width': '50rem' }"
      [paginator]="true"
      [rows]="10"
      [totalRecords]="totalRecords"
      [loading]="loading"
      selectionMode="single"
      (onRowSelect)="onRowSelect_AI($event)"
      [scrollable]="true"
      [style]="{ width: '100%' }"
      [scrollHeight]="innerHeight + 'vh'"
    >
      <ng-template pTemplate="header" let-columns>
        <tr>
          <ng-container *ngFor="let col of cols">
            <th *ngIf="!col?.hide" [style.minWidth.rem]="col.minWidth">
              <span [innerHTML]="col.label"></span>
              <span class="fts">
                <span class="filter" *ngIf="col.showFilter" (click)="toggleCustomColumnFilter(col.name)">
                  <ng-container *ngIf="col.filterVals; else notSelected">
                    <img alt="" class="filter-btn" src="{{ baseHref }}/assets/images/icon-filter-selected.png" />
                  </ng-container>
                  <ng-template #notSelected>
                    <img alt="" class="filter-btn" src="{{ baseHref }}/assets/images/icon-filter.png" />
                  </ng-template>
                </span>

                <span class="sort" (click)="sortByColumn(col.name)">
                  <ng-container *ngIf="col.hasOwnProperty('isAsc'); else others">
                    <ng-container *ngIf="col.isAsc; else falseBlock">
                      <img alt="" class="sort-btn" src="{{ baseHref }}/assets/images/icon-sort-up.png" />
                    </ng-container>
                    <ng-template #falseBlock>
                      <img alt="" class="sort-btn" src="{{ baseHref }}/assets/images/icon-sort-down.png" />
                    </ng-template>
                  </ng-container>

                  <ng-template #others>
                    <img alt="" class="sort-btn" src="{{ baseHref }}/assets/images/icon-sort.png" />
                  </ng-template>
                </span>
              </span>
            </th>
          </ng-container>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-rowData let-columns="columns">
        <tr [pSelectableRow]="rowData" style="height: 2.875rem">
          <ng-container *ngFor="let col of cols">
            <td *ngIf="!col?.hide">
              <!-- Default rendering -->
              <ng-container *ngIf="col.name !== 'AI Comments/Recommendations' && col.name !== 'Download' && col.name !== 'Status'">
                {{ col.type === 'date' ? (rowData[col.name] | custdate) : rowData[col.name] || '-' }}
              </ng-container>
              <ng-container *ngIf="col.name === 'Status'">
                <span *ngIf="rowData[col.name]; else statusEmpty"
                      class="status-badge"
                      [class.status-complete]="rowData[col.name]?.toLowerCase().includes('complete')"
                      [class.status-inprogress]="rowData[col.name]?.toLowerCase().includes('inprogress') || rowData[col.name]?.toLowerCase().includes('in progress')"
                      [class.status-submitted]="rowData[col.name]?.toLowerCase().includes('submitted')">
                  {{ rowData[col.name] }}
                </span>
                <ng-template #statusEmpty>-</ng-template>
              </ng-container>
              <ng-container *ngIf="col.name == 'Download' && rowData['Status'] == 'Submitted'">
                <span (click)="getExportExcel(rowData['SurveyID']); $event.stopPropagation()">
                  <img alt="" src="{{ baseHref }}/assets/images/icon-download.png"
                  class="download-icon"
                  title="Export"
                   />
                </span>
              </ng-container>
              <!-- Special case for Comments, Evaluations & Recommendations -->
              <ng-container *ngIf="col.name === 'AI Comments/Recommendations'">
                {{ rowData[col.label]}}
      
                <!-- <span>
                  <img alt="" src="{{ baseHref }}/assets/images/icon-evaluation-positive.png"
                    class="iconButton auditIconsCommonCSS iconEvaluationPositive"
                    title="Evaluations" />
                </span> -->
      
                <!-- <span (click)="openCommentPopup(rowData)">
                  <img alt="" src="{{ baseHref }}/assets/images/icon-calibrating-positive.png"
                    class="iconButton auditIconsCommonCSS iconCalibratingPositive"
                    title="Calibrations" />
                </span> -->
      
                <span (click)="openCommentPopup(rowData); $event.stopPropagation()">
                <img alt="" src="{{ baseHref }}/assets/images/icon-calibrating-positive.png"
                class="iconButton auditIconsCommonCSS iconCalibratingPositive"
                title="Calibrations" />
                </span>

                <!-- <span>
                  <img alt="" src="{{ baseHref }}/assets/images/icon-scorecard-positive.png"
                    class="iconButton auditIconsCommonCSS iconScorecardPositive"
                    title="Scorecards" />
                </span> -->
              </ng-container>
            </td>
          </ng-container>
        </tr>
      </ng-template>
      
      <!-- <ng-template pTemplate="body" let-rowData let-columns="columns">
        <tr [pSelectableRow]="rowData" style="height: 2.875rem">
          <ng-container *ngFor="let col of cols">
            <td *ngIf="!col?.hide">
              {{ col.type === 'date' ? (rowData[col.name] | custdate) : rowData[col.name] || '--' }}
            </td>
          </ng-container>
        </tr>
      </ng-template> -->
      <ng-template pTemplate="emptymessage" let-columns>
        <tr>
          <td [attr.colspan]="columns.length">No Data Available</td>
        </tr>
      </ng-template>
    </p-table>
    <p-dialog header="Final Summary and Comments"
          [(visible)]="commentDialogVisible"
          [modal]="true"
          [style]="{width: '50vw'}"
          [closable]="true">

          <div class="summary-container">
            <div *ngFor="let item of aiReviewComments">
              <div *ngIf="item.isArray; else textValue">
                <h3 class="section-header">{{ formatKey(item.key) }}</h3>
                  <p *ngFor="let val of item.value">
                    {{ val }}
                  </p>
              </div>

              <ng-template #textValue>
                <h3 class="section-header">{{ formatKey(item.key) }}</h3>
                <p>
                  {{ item.value }}
                </p>
              </ng-template>

            </div>
            <span *ngIf="aiReviewComments?.length == 0">No AI Audit Comments</span>
          </div>
          <div class="solid-headerDivider"></div>
          <ng-template pTemplate="footer"> 
            <button class="btn submit cancel-btn center-btn" type="button" (click)="commentDialogVisible=false"> Close </button>
          </ng-template>
    </p-dialog>
  </div>
</div>
